import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import axios from 'axios';
import API from './api';

// 将axios和API实例挂载到Vue原型上
Vue.prototype.$axios = axios;
Vue.prototype.$api = API;

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
